<template>
  <v-container>
    <!-- Cabeçalho -->
    <v-row justify="space-between" align="center" class="mb-4">
      <v-col><h1>Marketplace</h1></v-col>
      <v-col cols="auto">
        <v-btn color="primary" @click="dialog = true">Postar Venda</v-btn>
      </v-col>
    </v-row>

    <!-- FILTROS -->
    <v-row class="mb-6" align="center">
      <!-- Tipo de Venda -->
      <v-col cols="12" md="4">
        <v-select
          v-model="selectedType"
          :items="typeOptions"
          item-title="text"
          item-value="value"
          label="Tipo de Venda"
          dense
          clearable
        />
      </v-col>

      <!-- Classe -->
      <v-col cols="12" md="4">
        <v-select
          v-model="selectedClass"
          :items="classOptions"
          item-title="name"
          item-value="name"
          label="Classe"
          dense
          clearable
        />
      </v-col>

      <!-- Ordenação por Data -->
      <v-col cols="12" md="4">
        <v-select
          v-model="dateSort"
          :items="dateSortOptions"
          item-title="text"
          item-value="value"
          label="Ordenar por Data"
          dense
        />
      </v-col>
    </v-row>

    <!-- CARDS FILTRADOS E ORDENADOS -->
    <v-row>
      <v-col
        cols="12"
        sm="6"
        md="4"
        v-for="sale in filteredSales"
        :key="sale.id"
      >
        <v-card outlined>
          <v-carousel
            v-if="sale.images.length"
            hide-delimiter-background
            height="200"
          >
            <v-carousel-item
              v-for="(img, i) in sale.images"
              :key="i"
            >
              <v-img :src="img" aspect-ratio="1.7" />
            </v-carousel-item>
          </v-carousel>

          <v-card-title>{{ sale.seller }}</v-card-title>
          <v-card-subtitle class="d-flex justify-space-between">
            <span><strong>Classe:</strong> {{ sale.className }}</span>
            <span><strong>Player Level:</strong> {{ sale.playerLevel }}</span>
          </v-card-subtitle>

          <v-card-text>
            <p><strong>Preço:</strong>
              <span v-if="sale.type === 'gold'">
                {{ sale.price }} Gold
              </span>
              <span v-else>
                R$ {{ sale.price }}
              </span>
            </p>
            <p><strong>Tipo de Pagamento:</strong> {{ sale.paymentType }}</p>
            <p v-if="sale.receiveType">
              <strong>Recebimento:</strong> {{ sale.receiveType }}
            </p>
            <p><strong>Data da Postagem:</strong> {{ sale.date }}</p>
            <p><strong>Status:</strong> {{ sale.status }}</p>
            <p><strong>Descrição:</strong> {{ sale.description }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- MODAL DE POSTAR VENDA -->
    <v-dialog
      v-model="dialog"
      max-width="600px"
    >
      <v-card>
        <v-card-title>Postar Venda</v-card-title>
        <v-card-text>
          <v-form ref="saleForm" @submit.prevent="submitSale">
            <!-- 1) Personagem -->
            <v-select
              v-model="form.character"
              :items="characters"
              item-title="given_name"
              item-value="id"
              return-object
              label="Personagem"
              dense
              required
            />

            <!-- 2) Classe (preenchido automaticamente) -->
            <v-select
              v-model="form.className"
              :items="classOptions"
              item-title="name"
              item-value="name"
              label="Classe"
              dense
              required
            />

            <!-- 3) Player Level (preenchido automaticamente) -->
            <v-text-field
              v-model.number="form.player_level"
              type="number"
              label="Player Level"
              dense
              required
            />

            <!-- 4) Tipo de Venda -->
            <v-select
              v-model="form.type"
              :items="typeOptions"
              item-title="text"
              item-value="value"
              label="Tipo de Venda"
              dense
              required
            />

            <!-- Valor (só se não for troca) -->
            <v-text-field
              v-if="form.type !== 'exchange'"
              v-model.number="form.price"
              label="Valor"
              dense
              required
            />

            <!-- Tipo de Recebimento (só dinheiro) -->
            <v-select
              v-if="form.type === 'money'"
              v-model="form.receiveType"
              :items="receiveOptions"
              item-title="text"
              item-value="value"
              label="Tipo de Recebimento"
              dense
              required
            />

            <!-- Descrição -->
            <v-textarea
              v-model="form.description"
              label="Descrição"
              rows="3"
              dense
              required
            />

            <!-- Imagens -->
            <v-file-input
              v-model="form.images"
              accept="image/*"
              multiple
              label="Imagens do Item"
              prepend-icon="mdi-camera"
              dense
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="submitSale">Postar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  fetchSales,
  createSale,
  fetchCharacters
} from '@/services/api.js'
import classOptions from './jsonClasses/classes.json'

export default {
  name: 'MarketplaceView',
  data() {
    return {
      dialog: false,
      sales: [],
      characters: [],

      // filtros
      typeOptions: [
        { text: 'Dinheiro', value: 'money' },
        { text: 'Gold',      value: 'gold'  },
        { text: 'Troca',     value: 'exchange' }
      ],
      selectedType: null,

      classOptions,
      selectedClass: null,

      dateSortOptions: [
        { text: 'Mais recentes primeiro', value: 'desc' },
        { text: 'Mais antigas primeiro',  value: 'asc'  }
      ],
      dateSort: 'desc',

      // formulário de nova venda
      form: {
        character:     null,
        className:     null,
        player_level:  null,
        type:          'money',
        price:         null,
        receiveType:   null,
        description:   '',
        images:        []
      },
      receiveOptions: [
        { text: 'Pix',    value: 'Pix'    },
        { text: 'PayPal', value: 'PayPal' }
      ]
    }
  },
  async mounted() {
    await this.loadSales()
  },
  computed: {
    filteredSales() {
      let list = this.sales

      if (this.selectedType) {
        list = list.filter(s => s.type === this.selectedType)
      }
      if (this.selectedClass) {
        list = list.filter(s => s.className === this.selectedClass)
      }

      return list.slice().sort((a, b) => {
        if (this.dateSort === 'desc') {
          return a.date < b.date ? 1 : a.date > b.date ? -1 : 0
        } else {
          return a.date > b.date ? 1 : a.date < b.date ? -1 : 0
        }
      })
    }
  },
  watch: {
    dialog(open) {
      if (open) {
        this.resetForm()
        this.loadCharacters()
      }
    },
    'form.character'(newChar) {
      if (newChar) {
        // auto-preenche classe e level
        this.form.player_level = newChar.level
        const cls = this.classOptions.find(c => c.id === newChar.class_id)
        this.form.className = cls ? cls.name : null
      }
    }
  },
  methods: {
    async loadSales() {
      try {
        const data = await fetchSales()
        this.sales = data.map(r => ({
          id:          r.id,
          seller:      r.seller_mid,
          type:        r.type,
          price:       r.price,
          paymentType: r.payment_type,
          receiveType: r.receive_type,
          description: r.description,
          status:      r.status,
          date:        r.created_at.substr(0,10),
          images:      r.images.map(i => i.url),
          className:   r.class_name,
          playerLevel: r.player_level
        }))
      } catch (err) {
        console.error('Erro ao buscar anúncios:', err)
      }
    },
    async loadCharacters() {
      try {
        const token = localStorage.getItem('jwt_token')
        const { characters } = await fetchCharacters(token)
        this.characters = characters
      } catch (err) {
        console.error('Erro ao buscar personagens:', err)
      }
    },
    resetForm() {
      this.form = {
        character:     null,
        className:     null,
        player_level:  null,
        type:          'money',
        price:         null,
        receiveType:   null,
        description:   '',
        images:        []
      }
    },
    async submitSale() {
      const fd = new FormData()
      fd.append('seller_mid',     localStorage.getItem('mid'))
      fd.append('class_id',       this.form.className)
      fd.append('player_level',   this.form.player_level)
      fd.append('type',           this.form.type)
      fd.append('price',          this.form.price ?? '')
      fd.append(
        'payment_type',
        this.typeOptions.find(o => o.value === this.form.type).text
      )
      if (this.form.receiveType) {
        fd.append('receive_type', this.form.receiveType)
      }
      if (this.form.character) {
        fd.append('character_id', this.form.character.id)
      }
      fd.append('description', this.form.description)
      this.form.images.forEach(file => fd.append('images', file))

      try {
        await createSale(fd)
        this.dialog = false
        await this.loadSales()
      } catch (err) {
        console.error('Erro ao criar venda:', err)
      }
    }
  }
}
</script>

<style scoped>
/* Estilos adicionais aqui, se necessário */
</style>
